import { isNil } from "lodash-es";

export const encodeUrlParams = (params: Record<string, unknown>) => {
  return new URLSearchParams(
    Object.entries(params)
      .filter(([_, value]) => !isNil(value))
      .map(([key, value]) => [key, String(value)]),
  );
};
